import { createContext, useEffect, useState } from 'react';
import { Section, SectionsResponse, SectionResponse, CountriesResponse, Country } from '../../models/interfaces';
import topApi from '../../components/api/ToPApi';




type SectionsContextProps = {
    sections: Section[];
    totalPage: number;
    loadSections: (page: number) => Promise<void>;
    addSection: (section: Section) => Promise<string>;
    updateSection: (section: Section) => Promise<string>;
    deleteSection: (id: number) => Promise<string>;

}



export const SectionsContext = createContext({} as SectionsContextProps);

export const SectionsProvider = ({ children }: any) => {

    const [sections, setSections] = useState<Section[]>([]);
    const [totalPage, setTotalPage] = useState<number>(0);
    const pageSize = 25;



    useEffect(() => {
        loadSections(0);
    }, [])


    const loadSections = async (pageActual) => {

        const resp = await topApi.get<SectionsResponse>('/section/getSections');
        if (resp.status == 200) {
            setSections([...resp.data.sections]);
            setTotalPage(1);
        }


    }

    const addSection = async (section: Section) => {
        try {
            section.id = undefined;
            const resp = await topApi.post<SectionResponse>('/section/', { section });
            setSections([...sections, resp.data.section]);
            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }


    const updateSection = async (section: Section) => {
        try {
            const resp = await topApi.put<Section>(`/section/${section.id}`, { section });

            setSections(sections.map(prod => {
                return (prod.id === section.id)
                    ? resp.data["section"]
                    : prod;
            }));

            return 'success'

        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }


    }

    const deleteSection = async (id: number) => {
        try {
            await topApi.delete<Section>(`/section/${id}`);
            setSections((prevSections) =>
                prevSections.filter((section) => section.id! !== id)
            );
            return 'success'
        } catch (e) {
            const error = e.response?.data?.error;
            return error || "Ocurrió un error de comunicación, intente de nuevo.";
        }
    }



    return (
        <SectionsContext.Provider value={{ sections, totalPage, loadSections, addSection, updateSection, deleteSection }}>
            {children}
        </SectionsContext.Provider>
    );
}